import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingComponent from '../LoadingComponent';
const IsMonthRoute = ({ children }) => {
    const { userType, isAdmin, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingComponent/>;
      }
    if (isAdmin) {
        return children;
      }
    if (userType !== 'isMonth') {
      return <Navigate to="/access-denied" state={{ from: location }} />;
    }
  
    return children;
  };
  
  export default IsMonthRoute;